import { render, staticRenderFns } from "./EditableTableHeader.vue?vue&type=template&id=3bd00e3f&"
import script from "./EditableTableHeader.vue?vue&type=script&lang=js&"
export * from "./EditableTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports